<i18n
  src="@/locales/views/organization/projections/query_estimated_harvest/show_harvest_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      :name="routeName('list_harvest_processes')"
      :params="{
        organization_id: this.organization_id
      }"
    ></go-back-link>

    <bread-crumbs :labels="[module_name, harvest_process?.name]"></bread-crumbs>

    <template v-if="load_general_data">
      <tabs-container v-model="option_tabs" :with_routing="true" />

      <router-view
        :estimated_harvests="estimated_harvests"
        :estimated_containers="estimated_containers"
        :harvest_process_crop_size_groups="harvest_process_crop_size_groups"
      ></router-view>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/organization/requesters/projections/query_estimated_harvest/show_harvest_process.js";

export default {
  name: "OrgProjectionsQueryEstimatedHarvestShowHarvestProcess",
  props: {
    harvest_process_id: { required: true },
    organization_id: { required: true }
  },
  data() {
    return {
      load_general_data: false,
      harvest_process: {},
      estimated_containers: [],
      estimated_harvests: [],
      harvest_process_crop_size_groups: [],
      option_tabs: []
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchHarvestProcess();
      await this.fetchHarvestProcessCropSizeGroups();
      await this.fetchEstimatedHarvests();
      await this.fetchEstimatedContainers();
      this.fillOptions();
      this.load_general_data = true;
    },
    fetchHarvestProcess: async function () {
      let response = await Requester.fetchHarvestProcess(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process = response.data;
    },
    fetchEstimatedContainers: async function () {
      let response = await Requester.fetchEstimatedContainers(
        this.organization_id,
        this.harvest_process_id
      );
      this.estimated_containers = response.data;
    },
    fetchEstimatedHarvests: async function () {
      let response = await Requester.fetchEstimatedHarvests(
        this.organization_id,
        this.harvest_process_id
      );
      this.estimated_harvests = response.data;
      this.estimated_harvests.forEach(estimated_harvest => {
        estimated_harvest["proc_button_destroy"] = false;
      });
    },
    fetchHarvestProcessCropSizeGroups: async function () {
      let response = await Requester.fetchHarvestProcessCropSizeGroups(
        this.organization_id,
        this.harvest_process_id
      );
      this.harvest_process_crop_size_groups = response.data;
    },
    fillOptions: function () {
      this.option_tabs = [
        {
          name: this.$t("labels.estimated_harvests_title"),
          icon: "fa-solid fa-apple-crate",
          route: {
            name: this.routeName("show_harvest_process_estimated_harvests")
          }
        },
        {
          name: this.$t("labels.estimated_containers_title"),
          icon: "fa-solid fa-container-storage",
          route: {
            name: this.routeName("show_harvest_process_estimated_containers")
          }
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          organization_id: this.organization_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  }
};
</script>
